<template>
  <section id="home" class="hero">
    <div class="hero-background">
      <div class="hero-overlay"></div>
    </div>
    
    <div class="container">
      <div class="hero-content" data-aos="fade-up">
        <h1>{{ title || 'VI-GAS' }}</h1>
        <h2>{{ subtitle || 'Autoryzowany serwis urządzeń Viessmann' }}</h2>
       
        
        <div class="hero-buttons">
          <router-link :to="{ name: 'Contact' }" class="btn" aria-label="Przejdź do formularza kontaktowego">Skontaktuj się</router-link>
          <router-link :to="{ name: 'Services' }" class="btn btn-secondary" aria-label="Zobacz naszą ofertę usług">Zobacz ofertę</router-link>
        </div>
        
        <div class="emergency-contact">
          <div class="emergency-item">
            <h3>Zgłoszenia awarii</h3>
            <a href="tel:+48570422020" aria-label="Zadzwoń w sprawie awarii: 570 422 020">📞  570 422 020</a>
            <a href="tel:+48800080124" aria-label="Zadzwoń w sprawie awarii: 801 080 124">📞  801 080 124</a>
          </div>
        </div>
      </div>
    </div>
    
    <div class="hero-features" data-aos="fade-up" data-aos-delay="200">
      <div class="container">
        <div class="features-grid">
          <article class="feature-item">
            <div class="feature-icon" aria-hidden="true">🔥</div>
            <h3>Systemy grzewcze Viessmann</h3>
            <p>Nowoczesne systemy grzewcze</p>
          </article>
          <article class="feature-item">
            <div class="feature-icon" aria-hidden="true">♻️</div>
            <h3>Automatyka - dobór i montaż</h3>
            <p>Ekologiczne ogrzewanie na lata</p>
          </article>
          <article class="feature-item">
            <div class="feature-icon" aria-hidden="true">🔧</div>
            <h3>Modernizacja Kotłowni</h3>
            <p>Gwarancja najwyższej jakości usług</p>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  overflow: hidden;
  margin-top: -80px; // Offset the body padding to make hero full height
  padding-top: 100px; // But keep padding so content doesn't overlap navbar
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('../assets/hero-pattern.svg');
    opacity: 0.1;
  }
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  
  h1 {
    font-size: 4rem;
    font-weight: 800;
    margin-bottom: 10px;
    background: linear-gradient(45deg, #FF6B35, #FFD93D);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  h2 {
    font-size: 1.5rem;
    margin-bottom: 20px;
    font-weight: 400;
  }
  
  p {
    font-size: 1.2rem;
    margin-bottom: 40px;
    opacity: 0.9;
  }
}

.hero-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-bottom: 60px;
}

.emergency-contact {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 30px;
  margin: 0 auto;
  max-width: 400px;
  
  h3 {
    margin-bottom: 15px;
    font-size: 1.1rem;
  }
  
  a {
    display: block;
    color: #FFD93D;
    text-decoration: none;
    font-size: 1.1rem;
    font-weight: 600;
    margin: 5px 0;
    
    &:hover {
      color: white;
    }
  }
}

.hero-features {
  position: relative;
  z-index: 2;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  padding: 40px 0;
  margin-top: auto;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.feature-item {
  text-align: center;
  
  .feature-icon {
    font-size: 3rem;
    margin-bottom: 15px;
  }
  
  h3 {
    font-size: 1.1rem;
    margin-bottom: 10px;
  }
  
  p {
    opacity: 0.8;
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .hero {
    margin-top: -70px; // Adjust for mobile navbar height
    padding-top: 70px;
  }
  
  .hero-content {
    h1 {
      font-size: 2.5rem;
    }
    
    h2 {
      font-size: 1.2rem;
    }
    
    p {
      font-size: 1rem;
    }
  }
  
  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
</style>